// https://vuex.vuejs.org/en/mutations.html

import { set, toggle } from "@/utils/vuex";

export default {
  setWhiteLabel: set("whitelabel")
};
